<wl-composable-card [config]="cardConfig">
  @if (hasItemAlignedLeftOrRight) {
    <div class="row h-100">
      @if (settings?.itemAlignment === 'left') {
        <div class="col-12 col-lg-6 order-1 mb-2 mb-lg-0">
          <sc-placeholder
            name="basic-content"
            [rendering]="rendering"
          ></sc-placeholder>
        </div>
      }
      <div class="col-12 col-lg-6 order-2">
        <ng-template *ngTemplateOutlet="basicContent"></ng-template>
      </div>
      @if (settings?.itemAlignment === 'right') {
        <div class="col-12 col-lg-6 order-1 order-lg-3 mb-2 mb-lg-0">
          <sc-placeholder
            name="basic-content"
            [rendering]="rendering"
          ></sc-placeholder>
        </div>
      }
    </div>
  } @else {
    <wl-basic-content-partial-top-between
      [settings]="settings"
      [content]="content"
      [context]="context"
      class="h-100"
    >
      <sc-placeholder
        name="basic-content"
        [rendering]="rendering"
      ></sc-placeholder>
    </wl-basic-content-partial-top-between>
  }
</wl-composable-card>

<ng-template #basicContent>
  <wl-basic-content-partial-top-between
    [settings]="settings"
    [content]="content"
    [context]="context"
    class="h-100"
  >
    <sc-placeholder
      name="basic-content"
      [rendering]="rendering"
    ></sc-placeholder>
  </wl-basic-content-partial-top-between>
</ng-template>
